import { get } from './rest';

const rootUrl = `${process.env.API_URL}/datasources`;

export default {
	get: () => get(`${rootUrl}`)
};
